import { BlueArrowIcon } from '@/features/shared/Icons';
import { MuiButtonBase, MuiTypography } from '@/features/shared/material-ui';
import { mapLinkToProps } from '@/utils/helpers';
import clsx from 'clsx';
import React from 'react';
import { AccountNavigationItemProps } from '../AccountMenu.interfaces';
import useAccountNavigationItemStyles from './AccountNavigationItem.styles';

const AccountNavigationItem = ({ link, selected }: AccountNavigationItemProps) => {
  const classes = useAccountNavigationItemStyles();

  return (
    <MuiButtonBase
      {...mapLinkToProps(link)}
      className={clsx(classes.root, selected ? 'account-navigation-selected' : '')}
    >
      <MuiTypography className="hover-element" component="span" />
      <MuiTypography className="account-navigation-item-content" component="span">
        <MuiTypography component="span" className={classes.label}>
          {link?.displayText}
        </MuiTypography>
        <BlueArrowIcon direction="right" className="account-navigation-icon" />
      </MuiTypography>
    </MuiButtonBase>
  );
};

export default AccountNavigationItem;
